import { memo } from 'react'
import classNames from 'classnames'
import DOMPurify from 'dompurify'
import trashIcon from '../../../../images/common/trash-icon.svg'
import { sanitizeNoteHtml, DOMPURIFY_CONFIG } from '../../../../utils/noteHtmlSanitizer'
import './NoteItem.scss'

type Props = {
  id: string
  providerName: string
  dateTime: string
  noteValue?: string | undefined
  isTheLast: boolean
  /** Shows a trash button on the record when set (admins allowed to delete medical records). */
  onDelete?: (() => void) | undefined
  /** Accessible name of that trash button. */
  deleteLabel?: string | undefined
}

const deleteIconButtonStyle = {
  border: 'none',
  background: 'transparent',
  padding: 0,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
}

export const NoteItem = memo(({ id, providerName, dateTime, noteValue, isTheLast, onDelete, deleteLabel }: Props) => (
  <div className={classNames('note-item-main-wrapper', { lastItem: isTheLast })}>
    <div className='note-item-header'>
      <div className='note-item-text note-item-provider-name'>{providerName}</div>
      {onDelete ?
        <button type='button' aria-label={deleteLabel} onClick={onDelete} style={deleteIconButtonStyle}>
          <img src={trashIcon} alt='' width={24} height={24} />
        </button>
      : null}
    </div>
    <div className='note-item-text note-item-provider-date-time'>{dateTime}</div>
    <div
      id={id}
      className='note-item-text note-item-provider-date-note-value'
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sanitizeNoteHtml(noteValue), DOMPURIFY_CONFIG) }}
    />
  </div>
))
